/**
 * Converts a Map to a POJSO
 */
export function mapToObject<T>(map: Map<string, T>): Record<string, T> {
  return Array.from(map.entries()).reduce(
    (obj, [key, value]) => {
      obj[key] = value;

      return obj;
    },
    {} as Record<string, T>
  );
}
